import * as React from 'react';
import { PdsIconSend as PdsIconSendElement } from '@principal/design-system-icons-web';
import { IconSize, ValidIconColor } from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconSend = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-send',
  elementClass: PdsIconSendElement,
  react: React,
});
